import {
  PartnerPermissionTypes,
  Workflow,
  WorkflowType,
} from '@/client/services/api/graphql/gql/graphql';

export type BulkAudienceImportData = {
  usesBulkAudienceImport: boolean;
  bulkImportFileName: string;
};

export type AssignmentSpecificData = {
  simpleType: 'pointInTime' | 'automated' | null;
  addEscalationContacts: boolean;
  useCustomDueDate: boolean;
  customDueDate: string | null;
  setDueDate: boolean;
  formBoundType: WorkflowType | null;
  useAssignmentDelay: boolean;

  bulkAudienceImportData: BulkAudienceImportData;
  useHiredDateAudienceFilter: boolean;
  useExtendAccessAudienceFilter: boolean;
  audienceIsAll: boolean;
};

export type AssignmentFormData = Workflow & AssignmentSpecificData;

export const assignmentFormDefaultValues: Omit<
  AssignmentFormData,
  'percentComplete' | 'resultGroupCount'
> = {
  audienceIsAll: false,
  useExtendAccessAudienceFilter: false,
  useHiredDateAudienceFilter: false,
  bulkAudienceImportData: {
    usesBulkAudienceImport: false,
    bulkImportFileName: '',
  },
  enabled: true,
  resultCount: 0,
  simpleType: null,
  addEscalationContacts: false,
  useCustomDueDate: true,
  customDueDate: null,
  setDueDate: false,
  formBoundType: WorkflowType.PointInTime,
  useAssignmentDelay: false,
  id: '',
  createdAt: '',
  updatedAt: '',
  user: {
    id: '',
    fullName: '',
  },
  audience: [],
  triggeredForUsersCount: 0,
  settings: {
    assignmentOptions: {
      delay: undefined,
    },
    conditionals: [],
    daysToComplete: undefined,
    dueFromHired: false,
    escalateBuddy: false,
    escalateManager: false,
    escalationContacts: [],
    name: '',
    nonReminderMessages: [],
    objectNumber: undefined,
    objectType: undefined,
    overdueMessages: [],
    partnerPermissions: PartnerPermissionTypes.Tenant,
    reminderMessages: [],
    requireRecompletion: false,
    responses: [],
    shareOptions: {
      emailBody: undefined,
      emailFromEmail: undefined,
      emailFromName: undefined,
      emailSubject: undefined,
    },
    triggerObject: undefined,
    type: WorkflowType.PointInTime,
  },
};
